<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div class="main" v-if="showMain">
      <div class="frour">
        <div>
            <FrameControl>
              <RegisterSituation></RegisterSituation>
            </FrameControl>
        </div>
        <div>
          <div style="width: 100%; height: 100%">
            <FrameControl>
                <StaySituation></StaySituation>
            </FrameControl>
          </div>
        </div>
        <div>
            <FrameControl>
            <OrderMaintenance></OrderMaintenance>
            </FrameControl>
        </div>
        <div>
            <FrameControl>
            <div class="icondiv">
              <div>
                <el-button type="text"
                           @click="EventPlanning">
                    <div>
                      <div>
                      <i class="icon iconfont icon-xianxiahuodongcehuajiladizhihang"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>活动策划</div>
                  </div>
                </el-button>
              </div>
              <div>
                <el-button type="text"
                    @click="SiteInquiry"       >
                    <div>
                      <div>
                      <i class="icon iconfont icon-inquiry"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>场地询价</div>
                  </div>
                </el-button>
              </div>
              <div>
                <el-button type="text"
                           @click="SignInClick">
                    <div>
                      <div>
                      <i class="icon iconfont icon-qiandao"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>签到管理</div>
                  </div>
                </el-button>
              </div>
              <div>
                <el-button type="text"
                           @click="StayArrangeClick">
                  <div>
                    <div>
                      <i class="icon iconfont icon-jiudianzhusu"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>住宿管理</div>
                  </div>
                </el-button>
              </div>
              
              <div>
                <el-button type="text"
                           @click="RestaurantArrangeClick">
                  <div>
                    <div>
                      <i class="icon iconfont icon-canyin"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>餐饮安排</div>
                  </div>
                </el-button>
              </div>
              <div>
                <el-button type="text"
                           @click="CarDispatchClick">
                  <div>
                    <div>
                      <i class="icon iconfont icon-qiche"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>车辆调度</div>
                  </div>
                </el-button>
              </div>
  
              <div>
                <el-button type="text"
                           @click="EmergenciesClick">
                  <div>
                    <div>
                      <i class="icon iconfont icon-manage-order"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>秩序维护</div>
                  </div>
                </el-button>
              </div>
              <div>
                <el-button type="text"
                           @click="FeedbackSurvey">
                  <div>
                    <div>
                      <i class="icon iconfont icon-zaixiantiaocha"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>反馈调查</div>
                  </div>
                </el-button>
              </div>
              <div>
                <el-button type="text"
                           @click="ServiceSummary">
                  <div>
                    <div>
                      <i class="icon iconfont icon-zongjie"
                         style="font-size:calc(100vw * 80 / 1920)"></i>
                    </div>
                    <div>会展服务总结</div>
                  </div>
                </el-button>
              </div>
            </div>
          </FrameControl>
        </div>
      </div>
      <SpeciesAnalyzed :closeValue="'TypeBiome'" @closeMoule="closeMoule"></SpeciesAnalyzed>
    </div>
    
  </ShowControl>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import RegisterSituation from "../ExhibitionServices/RegisterSituation.vue";
  import StaySituation from "../ExhibitionServices/StaySituation.vue";
  import OrderMaintenance from "../ExhibitionServices/OrderMaintenance.vue";
  import ShowControl from "../UserControl/ShowControl.vue"
  import FrameControl from "../UserControl/FrameControl.vue"
  export default {
    components: {
      RegisterSituation,
      StaySituation,
      OrderMaintenance,
      ShowControl,
      FrameControl,
    },
    data () {
      return {
        AIGenerateCardView:false,
        caseID: localStorage.getItem("caseId"),
        showMain:true,
        title: '会展服务',
        eventForm: {},
        complaintFrom: {},
        siteFrom: {},
        flowID: localStorage.getItem("flowID"),
        };
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
      }),
    },
    created () {
    },
    mounted () {
      if (this.$route.query.str != undefined) {
        this.cardview(this.$route.query.str);
      }
    },
    beforeRouteUpdate(to,from,next)
    {
      next(vm=>
      {
        console.log(vm);
      })
      if (to.query.str != undefined) {
        this.cardview(to.query.str);
      }
    },
    provide(){
      return {
        GetAllLoanTypes:this.GetAllLoanTypes
      }
    },
    methods: {
      cardview(str)
      {
        if(str=='EventPlanningCard')
        {
          this.$router.push("/EventPlanningCard")
        }else if(str=='StayArrangeCard')
        {
          this.$router.push("/StayArrangeCard")
        }
        else if(str=='CarDispatchCard')
        {
          this.$router.push("/CarDispatchCard")
        }
        else if(str=='RestaurantArrangeCard')
        {
          this.$router.push("/RestaurantArrangeCard")
        }
        else if(str=='EmergenciesCard')
        {
          this.$router.push("/EmergenciesCard")
        }
        else if(str=='FeedbackSurveyCard')
        {
          this.$router.push("/FeedbackSurveyCard")
        }
      },
      SignInClick(){
        this.$router.push("/SignInCard")
      },
      StayArrangeClick(){
        this.$router.push("/StayArrangeCard")
      },
      RestaurantArrangeClick(){
        this.$router.push("/RestaurantArrangeCard")
      },
      CarDispatchClick(){
        this.$router.push("/CarDispatchCard")
      },
      EmergenciesClick(){
        this.$router.push("/EmergenciesCard")
      },
      SiteInquiry()
      {
        this.$router.push("/SiteInquiryCard")
      },
      EventPlanning()
      {
        this.$router.push("/EventPlanningCard")
      },
      ServiceSummary()
      {
        if (this.flowID != this.Global.FlowList.实验总结) {
          this.$message.error("当前流程阶段不是实验总结，无法进行操作！");
          return;
        }
        this.$router.push("/ServiceSummaryCard")
      },
      FeedbackSurvey()
      {
        this.$router.push("/FeedbackSurveyCard")
      },
    }
  };
  </script>
  
  <style lang="less" scoped>
  .icondiv {
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    height: 100%;
    align-content: center;
    align-items: center;
    overflow: auto;
    > div {
      display: flex;
      width: 17%;
      text-align: center;
      height: 45%;
      justify-content: center;
    }
  }
  </style>
  <style scoped>
  .main {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
  }
  .frour {
    /* background-color: #e8e8e8; */
    display: flex;
    /* flex: auto; */
    justify-content: center;
    /* align-content: center;
    align-items: center; */
    flex-wrap: wrap;
    height: 100%;
    border-radius: 0px 0px 15px 15px;
  }
  .frour > div {
    display: flex;
    flex-wrap: wrap;
    margin: 10px;
    height: calc((100% - 40px) / 2);
    width: calc((100% - 60px) / 2);
  }
  </style>
  